import { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";

// Imports de Navbar y contexto si los tienes
import { NavBarAdm } from "../Components/NavBarAdm";

//Import Hooks
import { useDataContext } from "../Context/dataContext";
import { useAxiosInterceptors } from "../Hooks/useAxiosInterceptors";
import { useCurrencyPrice } from "../Hooks/useCurrencyPrice";
import { useFetchMovements } from "../Hooks/useFetchMovements";
import { useFetchDataAdm } from "../Hooks/useFetchDataAdm";
import { useFetchTotal } from "../Hooks/useFetchTotal";

// Importaciones de Iconos
import { FaEye, FaEyeSlash, FaClock } from "react-icons/fa";
import {
  HiOutlineUpload,
  HiOutlineDocumentText,
  HiOutlineCurrencyDollar,
} from "react-icons/hi";

// Importaciones para Loadings
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Import imágenes de banderas
import europa1 from "../Assets/Images/europa1.png";
import usa1 from "../Assets/Images/usa1.png";
import uk1 from "../Assets/Images/uk1.png";
import logo from "../Assets/Images/remesalogo.png";

// Dashboard Admin
function Dashboard() {
  // Context and hooks
  useAxiosInterceptors();
  const { url, accessToken } = useDataContext();
  const { userMovements } = useFetchMovements(accessToken.access_token);
  const { user } = useFetchDataAdm(accessToken.access_token);
  const { totalEur, totalUsd, totalGbp, totalUsers, totalUsersV, totalUsersP } =
    useFetchTotal(accessToken.access_token);
  const history = useHistory();
  const { data } = useCurrencyPrice();
  const { exchangeRates } = useCurrencyPrice();

  // Estados de modal y procesamiento
  const [isProcessing, setIsProcessing] = useState(false);
  const [actionResult, setActionResult] = useState(null); // 'success' | 'error' | null

  // Estado de modal de recarga
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

  // Estado mostrar razón de rechazo en remesas
  const [showRejectionReason, setShowRejectionReason] = useState(false);

  // Estado de la razón de rechazo
  const [rejectionReason, setRejectionReason] = useState("");

  // Estado de la moneda seleccionada
  const [payment, setPayment] = useState("");

  // Estado de imagen subida
  const [movImg, setMovImg] = useState(null);

  // Estado si hay un archivo seleccionado
  const [fileSelected, setFileSelected] = useState(false);


  // Handlers ficticios
  const closeDetailModal = () => {
    setIsDetailModalOpen(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setShowRejectionReason(false);
  };

  //Agregar saldo después de recargar
  const handleSubmitSummary = async (isRejectedParam = false) => {
    const totalAmountEur = parseFloat(selectedMovement.User.use_amountEur);
    const totalAmountUsd = parseFloat(selectedMovement.User.use_amountUsd);
    const totalAmountGbp = parseFloat(selectedMovement.User.use_amountGbp);
    const formData = new FormData();
    if (selectedMovement.mov_currency === "EUR") {
      formData.append(
        "use_amountEur",
        totalAmountEur + selectedMovement.mov_amount
      );
    }
    if (selectedMovement.mov_currency === "USD") {
      formData.append(
        "use_amountUsd",
        totalAmountUsd + selectedMovement.mov_amount
      );
    }
    if (selectedMovement.mov_currency === "GBP") {
      formData.append(
        "use_amountGbp",
        totalAmountGbp + selectedMovement.mov_amount
      );
    }

    try {
      await axios.put(
        `${url}/Users/${selectedMovement.User.use_id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken.access_token}`,
          },
        }
      );

      if (
        !selectedMovement.User.use_hasReceivedReferralBonus &&
        isRejectedParam === false
      ) {
        await axios.get(
          `${url}/Movements/VerifMovementWithReferralBonus/${selectedMovement.mov_id}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
      }
      console.log("Request send successfully");
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsProcessing(false);
      setActionResult("success");
      window.location.reload();
    }
  };

  // Simular aprobar recarga
  const handleApproveRecarga = async (event) => {
    event.preventDefault();
    setIsProcessing(true);
    const formData = new FormData();
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    formData.append("mov_date", formattedDate);

    try {
      await axios.get(`${url}/Movements/verif/${selectedMovement.mov_id}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken.access_token}`,
        },
      });

      await axios.put(`${url}/Movements/${selectedMovement.mov_id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken.access_token}`,
        },
      });

      await axios.post(
        `${url}/Mailer/EmailVtransfer/${selectedMovement.User.use_email}/${selectedMovement.mov_id}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${accessToken.access_token}`,
          },
        }
      );

      if (selectedMovement.mov_currency === "EUR") {
        await axios.post(
          `${url}/TotalRegister/create`,
          {
            tor_accEurId: selectedMovement.AccountsEur.acceur_id,
            tor_currencyPrice: data.cur_EurToBs,
            tor_date: formattedDate,
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
      }
      if (selectedMovement.mov_currency === "USD") {
        await axios.post(
          `${url}/TotalRegister/create`,
          {
            tor_accUsdId: selectedMovement.AccountsUsd.accusd_id,
            tor_currencyPrice: data.cur_UsdToBs,
            tor_date: formattedDate,
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
      }
      if (selectedMovement.mov_currency === "GBP") {
        await axios.post(
          `${url}/TotalRegister/create`,
          {
            tor_accGbpId: selectedMovement.AccountsGbp.accgbp_id,
            tor_currencyPrice: data.cur_GbpToBs,
            tor_date: formattedDate,
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
      }

      closeDetailModal();
      handleSubmitSummary();

      console.log("Request sent successfully");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Simular rechazar recarga
  const handleRejectRecarga = async (event) => {
    event.preventDefault();
    setIsProcessing(true);

    try {
      // Rechazar el movimiento
      await axios.get(`${url}/Movements/reject/${selectedMovement.mov_id}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken.access_token}`,
        },
      });

      // Actualizar comentario con la razón del rechazo
      await axios.put(
        `${url}/Movements/${selectedMovement.mov_id}`,
        {
          mov_comment: rejectionReason,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken.access_token}`,
          },
        }
      );

      // Si es un retiro, ejecutar acciones adicionales
      if (selectedMovement.mov_type === "Retiro") {
        handleSubmitSummary();
      }

      // Cerrar modales y actualizar los movimientos
      closeDetailModal();
      closeModal();
      window.location.reload();

      await axios.post(
        `${url}/Mailer/EmailRtransfer/${selectedMovement.User.use_email}/${selectedMovement.mov_id}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${accessToken.access_token}`,
          },
        }
      );

      console.log("Request sent successfully");
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsProcessing(false);
      setActionResult("error");
    }
  };

  // Simular aprobar remesa
  const handleApproveRemesa = async (event) => {
    event.preventDefault();
    setIsProcessing(true);

    const formData = new FormData();
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);

    if (selectedMovement.mov_typeOutflow === "efectivo") {
      formData.append("mov_currency", "USD");
      formData.append("mov_accEurId", 0);
      formData.append("mov_accGbpId", 0);
      formData.append("mov_amount", selectedMovement.mov_amount);
      formData.append("mov_date", formattedDate);
      formData.append("mov_currencyPrice", 1);
    } else {
      formData.append(
        "mov_currency",
        selectedMovement.mov_currency === "USD" ||
          selectedMovement.mov_currency === "EUR" ||
          selectedMovement.mov_currency === "GBP"
          ? payment
          : selectedMovement.mov_currency
      );
      formData.append("mov_accEurId", 0);
      formData.append("mov_accGbpId", 0);
      formData.append("mov_accUsdId", payment === "USD" ? 99 : 0);
      formData.append("mov_accBsId", payment === "BS" ? 1 : 0);
      formData.append("mov_img", movImg);
      formData.append(
        "mov_amount",
        selectedMovement.mov_currency === payment
          ? parseFloat(selectedMovement.mov_amount)
          : selectedMovement.mov_currency === "USD" &&
            selectedMovement.mov_currency !== payment
          ? parseFloat(selectedMovement.mov_amount) *
            selectedMovement.mov_currencyPrice
          : selectedMovement.mov_currency === "EUR"
          ? parseFloat(selectedMovement.mov_amount) *
            selectedMovement.mov_currencyPrice
          : selectedMovement.mov_currency === "GBP"
          ? parseFloat(selectedMovement.mov_amount) *
            selectedMovement.mov_currencyPrice
          : parseFloat(selectedMovement.mov_amount)
      );
      formData.append("mov_date", formattedDate);
    }

    try {
      await axios.put(`${url}/Movements/${selectedMovement.mov_id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken.access_token}`,
        },
      });

      await axios.get(`${url}/Movements/verif/${selectedMovement.mov_id}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken.access_token}`,
        },
      });

      await axios.post(
        `${url}/Mailer/EmailVtransfer/${selectedMovement.User.use_email}/${selectedMovement.mov_id}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${accessToken.access_token}`,
          },
        }
      );

      if (!selectedMovement.User.use_hasReceivedReferralBonus) {
        await axios.get(
          `${url}/Movements/VerifMovementWithReferralBonus/${selectedMovement.mov_id}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
      }

      // Registrar el cambio en TotalRegister dependiendo de la moneda
      if (selectedMovement.mov_currency === "EUR" && payment === "BS") {
        await axios.post(
          `${url}/TotalRegister/create`,
          {
            tor_accBsId: 1,
            tor_currencyPrice: parseFloat(data.cur_EurToBs),
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
      }
      if (selectedMovement.mov_currency === "EUR" && payment === "USD") {
        await axios.post(
          `${url}/TotalRegister/create`,
          {
            tor_accUsdId: 1,
            tor_currencyPrice: parseInt(data.cur_EurToUsd),
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
      }
      if (selectedMovement.mov_currency === "USD" && payment === "BS") {
        await axios.post(
          `${url}/TotalRegister/create`,
          {
            tor_accBsId: 1,
            tor_currencyPrice: parseFloat(data.cur_UsdToBs),
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
      }
      if (selectedMovement.mov_currency === "USD" && payment === "USD") {
        await axios.post(
          `${url}/TotalRegister/create`,
          {
            tor_accUsdId: 1,
            tor_currencyPrice: 1,
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
      }
      if (selectedMovement.mov_currency === "GBP" && payment === "BS") {
        await axios.post(
          `${url}/TotalRegister/create`,
          {
            tor_accBsId: 1,
            tor_currencyPrice: parseFloat(data.cur_GbpToBs),
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
      }
      if (selectedMovement.mov_currency === "GBP" && payment === "USD") {
        await axios.post(
          `${url}/TotalRegister/create`,
          {
            tor_accUsdId: 1,
            tor_currencyPrice: parseFloat(data.cur_GbpToUsd),
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
      }

      // Cerrar el modal
      closeModal();
      window.location.reload();
      console.log("Request sent successfully");
    } catch (error) {
      console.error("Error:", error);
      // Manejo de errores, puedes mostrar un mensaje al usuario
      setActionResult("error");
      setIsProcessing(false);
    } finally {
      setIsProcessing(false);
    }
  };

  // Simular rechazar remesa
  const handleRejectRemesa = async () => {
    setIsProcessing(true);

    try {
      // Rechazar el movimiento
      await axios.get(`${url}/Movements/reject/${selectedMovement.mov_id}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken.access_token}`,
        },
      });

      // Actualizar comentario con la razón del rechazo
      await axios.put(
        `${url}/Movements/${selectedMovement.mov_id}`,
        {
          mov_comment: rejectionReason,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken.access_token}`,
          },
        }
      );

      if (selectedMovement.mov_type === "Retiro") {
        await handleSubmitSummary(true);
      }

      // Cerrar modales y actualizar los movimientos
      closeDetailModal();
      closeModal();

      await axios.post(
        `${url}/Mailer/EmailRtransfer/${selectedMovement.User.use_email}/${selectedMovement.mov_id}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${accessToken.access_token}`,
          },
        }
      );

      console.log("Request sent successfully");
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsProcessing(false);
      setActionResult("error");
    }
  };

  // Estado de pestaña activa
  const [activeTab, setActiveTab] = useState("recargas");

  // Función para cambiar de pestaña
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // Estados de modal y movimiento seleccionado
  const [selectedMovement, setSelectedMovement] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Estado para mostrar/ocultar saldos
  const [showBalances, setShowBalances] = useState({
    eur: true,
    usd: true,
    gbp: true,
  });

  // Fecha
  const currentDate = new Date().toLocaleDateString("es-ES", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="dashboard-page">
      {/* Header */}
      <div className="changes-header">
        <div className="header-row">
          <div className="user-avatar">
            <img src={logo} alt="Admin" />
          </div>
          <div className="header-text">
            <h2>
              Hola, {user?.adm_user || <Skeleton width={100} />}{" "}
              <span className="wave" role="img" aria-label="wave">
                👋
              </span>
            </h2>
            <p className="current-date">{currentDate}</p>
          </div>
        </div>
      </div>

      {/* Wallet cards */}
      <div className="wallet-section">
        <div className="wallet-card">
          <div className="wallet-card-top">
            <div className="wallet-card-label">
              <h4>Total de Usuarios</h4>
              <span className="wallet-subtitle">Registrados</span>
            </div>
          </div>
          <div className="wallet-card-middle">
            <div className="wallet-card-balance">
              {totalUsers || <Skeleton width={100} />}
            </div>
          </div>
          <div className="wallet-card-footer">
            <span className="last-update">Actualizado hoy</span>
          </div>
        </div>

        <div className="wallet-card">
          <div className="wallet-card-top">
            <div className="wallet-card-label">
              <h4>Usuarios Verificados</h4>
              <span className="wallet-subtitle">Identidad confirmada</span>
            </div>
          </div>
          <div className="wallet-card-middle">
            <div className="wallet-card-balance">
              {totalUsersV || <Skeleton width={100} />}
            </div>
          </div>
          <div className="wallet-card-footer">
            <span className="last-update">Actualizado hoy</span>
          </div>
        </div>

        <div className="wallet-card">
          <div className="wallet-card-top">
            <div className="wallet-card-label">
              <h4>Usuarios en Espera</h4>
              <span className="wallet-subtitle">
                Pendientes de verificación
              </span>
            </div>
          </div>
          <div className="wallet-card-middle">
            <div className="wallet-card-balance">
              {totalUsersP || <Skeleton width={100} />}
            </div>
          </div>
          <div className="wallet-card-footer">
            <span className="last-update">Actualizado hoy</span>
          </div>
        </div>

        {["eur", "gbp", "usd"].map((currency) => (
          <div className="wallet-card" key={currency}>
            <div className="wallet-card-top">
              <div className="wallet-card-label">
                <h4>
                  {currency.toUpperCase()} (
                  {currency === "eur" ? "€" : currency === "usd" ? "$" : "£"})
                </h4>
                <span className="wallet-subtitle">Recargado hoy</span>
              </div>
              <img
                src={
                  {
                    eur: europa1,
                    usd: usa1,
                    gbp: uk1,
                  }[currency]
                }
                alt={currency}
                className="wallet-card-flag"
              />
            </div>

            <div className="wallet-card-middle">
              <div className="wallet-card-balance">
                {showBalances[currency]
                  ? {
                      eur: totalEur ? totalEur.totalIn : "0.00",
                      usd: totalUsd ? totalUsd.totalIn : "0.00",
                      gbp: totalGbp ? totalGbp.totalIn : "0.00",
                    }[currency] +
                    " " +
                    currency.toUpperCase()
                  : "••••••••"}
              </div>
              <button
                className="toggle-visibility"
                onClick={() =>
                  setShowBalances((prev) => ({
                    ...prev,
                    [currency]: !prev[currency],
                  }))
                }
                aria-label="Mostrar/Ocultar saldo"
              >
                {showBalances[currency] ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Botones */}
      <div className="wallet-summary-actions">
        <button
          onClick={() => history.push("/Relation")}
          className="wallet-button-primary"
        >
          <HiOutlineUpload /> Relación
        </button>
        <button
          onClick={() => history.push("/Users")}
          className="wallet-button-secondary"
        >
          <HiOutlineDocumentText /> Ver Usuarios
        </button>
        <button
          onClick={() => history.push("/CurrencyUpdate")}
          className="wallet-button-secondary" 
        >
          <HiOutlineCurrencyDollar /> Ver Tasas
        </button>
      </div>

      {/* Tabla */}
      <div className="transactions-section">
        {/* Tabs */}
        <div className="tabs">
          <button
            className={activeTab === "recargas" ? "active" : ""}
            onClick={() => handleTabChange("recargas")}
          >
            Movimientos de Recarga (
            {userMovements.filter((m) => m.mov_type === "Deposito").length})
          </button>
          <button
            className={activeTab === "remesas" ? "active" : ""}
            onClick={() => handleTabChange("remesas")}
          >
            Movimientos de Remesas (
            {userMovements.filter((m) => m.mov_type === "Retiro").length})
          </button>
        </div>

        {/* Tabla de Recargas */}
        {activeTab === "recargas" && (
          <div className="table-responsive">
            <table className="movements__table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Usuario</th>
                  <th>Referencia</th>
                  <th>Monto</th>
                  <th>Estado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {userMovements.filter((m) => m.mov_type === "Deposito")
                  .length ? (
                  userMovements
                    .filter((m) => m.mov_type === "Deposito")
                    .map((m) => (
                      <tr key={m.mov_id}>
                        <td>{m.mov_date}</td>
                        <td>
                          {m.User?.use_name} {m.User?.use_lastName}
                        </td>
                        <td>{m.mov_ref}</td>
                        <td>
                          {m.mov_currency === "EUR"
                            ? "€"
                            : m.mov_currency === "USD"
                            ? "$"
                            : "£"}
                          {m.mov_amount}
                          <img
                            src={
                              {
                                EUR: europa1,
                                USD: usa1,
                                GBP: uk1,
                              }[m.mov_currency]
                            }
                            alt={m.mov_currency}
                            className="currency-flag"
                          />
                        </td>
                        <td>
                          <span className="status-tag E">
                            <FaClock /> En espera
                          </span>
                        </td>
                        <td>
                          <FaEye
                            className="view-details-icon"
                            onClick={() => {
                              setSelectedMovement(m);
                              setIsDetailModalOpen(true);
                            }}
                          />
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>
                      No hay recargas pendientes.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Tabla de Remesas */}
        {activeTab === "remesas" && (
          <div className="table-responsive">
            <table className="movements__table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Usuario</th>
                  <th>Remesa</th>
                  <th>Beneficiario</th>
                  <th>Enviado</th>
                  <th>Recibido</th>
                  <th>Estado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {userMovements.filter((m) => m.mov_type === "Retiro").length ? (
                  userMovements
                    .filter((m) => m.mov_type === "Retiro")
                    .map((m) => (
                      <tr key={m.mov_id}>
                        <td>{m.mov_date}</td>
                        <td>
                          {m.User?.use_name} {m.User?.use_lastName}
                        </td>
                        <td>{m.mov_ref}</td>
                        <td>
                          {m.AccountsBsUser
                            ? m.AccountsBsUser.accbsUser_owner
                            : m.mov_typeOutflow === "efectivo"
                            ? "Retiro en Efectivo"
                            : "Sin beneficiario"}
                        </td>
                        <td>
                          {m.mov_oldAmount}
                          {m.mov_currency === "EUR"
                            ? "€"
                            : m.mov_currency === "USD"
                            ? "$"
                            : "£"}
                          <img
                            src={
                              {
                                EUR: europa1,
                                USD: usa1,
                                GBP: uk1,
                              }[m.mov_currency]
                            }
                            alt={m.mov_currency}
                            className="currency-flag"
                          />
                        </td>
                        <td>
                          {m.mov_typeOutflow === "efectivo" && (
                            <>
                              {parseFloat(m.mov_amount).toLocaleString("de-DE")} USD
                            </>
                          )}
                          {m.mov_typeOutflow !== "efectivo" && (
                            parseFloat(m.mov_amount) *
                            (exchangeRates.find(
                              (rate) =>
                                rate.country ===
                                  m.AccountsBsUser?.accbsUser_country &&
                                rate.oldCurrency === m.mov_currency
                            )?.value || 0)
                          ).toLocaleString("de-DE")}
                        </td>
                        <td>
                          <span className="status-tag E">
                            <FaClock /> En espera
                          </span>
                        </td>
                        <td>
                          <FaEye
                            className="view-details-icon"
                            onClick={() => {
                              setSelectedMovement(m);
                              setIsModalOpen(true);
                            }}
                          />
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="8" style={{ textAlign: "center" }}>
                      No hay remesas pendientes.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal de Recarga */}
      {isDetailModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            {isProcessing ? (
              <>
                {actionResult === null && <div className="spinner"></div>}
                {actionResult === "success" && (
                  <div className="checkmark">
                    <svg viewBox="0 0 52 52">
                      <path
                        className="checkmark__check"
                        fill="none"
                        d="M14 27l7 7 17-17"
                      />
                    </svg>
                  </div>
                )}
                {actionResult === "error" && <div className="xmark"></div>}
              </>
            ) : (
              <>
                <h3>Comprobante de Recarga</h3>
                {selectedMovement?.mov_img ? (
                  selectedMovement.mov_img.endsWith(".pdf") ? (
                    <button
                      type="button"
                      className="comprobante-link"
                      onClick={() => {
                        window.open(
                          `${url}/Movements/image/${selectedMovement.mov_img}`,
                          "_blank"
                        );
                      }}
                    >
                      Descargar PDF
                    </button>
                  ) : (
                    <img
                      src={`${url}/Movements/image/${selectedMovement.mov_img}`}
                      alt="Comprobante"
                      style={{ width: "100%", borderRadius: "12px" }}
                    />
                  )
                ) : (
                  <p>No hay comprobante disponible.</p>
                )}
                {!showRejectionReason ? (
                  <div className="modal-buttons">
                    <button
                      className="approve-btn"
                      onClick={handleApproveRecarga}
                    >
                      Aprobar
                    </button>
                    <button
                      className="reject-btn"
                      onClick={() => setShowRejectionReason(true)}
                    >
                      Rechazar
                    </button>
                  </div>
                ) : (
                  <div className="rejection-reason open">
                    <label>Motivo del rechazo:</label>
                    <textarea
                      value={rejectionReason}
                      onChange={(e) => setRejectionReason(e.target.value)}
                    />
                    <div className="modal-buttons">
                      <button
                        className="send-btn"
                        onClick={handleRejectRecarga}
                      >
                        Enviar
                      </button>
                      <button
                        className="btn-back"
                        onClick={() => setShowRejectionReason(false)}
                      >
                        Volver
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
            <div className="modal-actions">
              <button
                className="close-btn"
                onClick={() => {
                  setIsDetailModalOpen(false);
                  setSelectedMovement(null);
                  setIsProcessing(false);
                  setActionResult(null);
                  setShowRejectionReason(false);
                  setRejectionReason("");
                }}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Remesa */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            {isProcessing ? (
              <>
                {actionResult === null && <div className="spinner"></div>}
                {actionResult === "success" && (
                  <div className="checkmark">
                    <svg viewBox="0 0 52 52">
                      <path
                        className="checkmark__check"
                        fill="none"
                        d="M14 27l7 7 17-17"
                      />
                    </svg>
                  </div>
                )}
                {actionResult === "error" && <div className="xmark"></div>}
              </>
            ) : (
              <>
                <h3>Detalles de la Remesa</h3>
                <div className="modal-details">
                  {selectedMovement?.AccountsBsUser?.accbsUser_bank &&
                  selectedMovement.AccountsBsUser.accbsUser_bank !==
                    "Efectivo" ? (
                    // TRANSFERENCIA
                    <>
                      <p>
                        <strong>Propietario:</strong>{" "}
                        {selectedMovement.AccountsBsUser.accbsUser_owner}
                      </p>
                      <p>
                        <strong>Banco:</strong>{" "}
                        {selectedMovement.AccountsBsUser.accbsUser_bank}
                      </p>
                      <p>
                        <strong>DNI:</strong>{" "}
                        {selectedMovement.AccountsBsUser.accbsUser_dni || "N/A"}
                      </p>
                      {selectedMovement.AccountsBsUser.accbsUser_type ===
                      "Pago Móvil" ? (
                        <p>
                          <strong>Teléfono:</strong>{" "}
                          {selectedMovement.AccountsBsUser.accbsUser_phone}
                        </p>
                      ) : (
                        <p>
                          <strong>Cuenta:</strong>{" "}
                          {selectedMovement.AccountsBsUser.accbsUser_number}{" "}
                          {selectedMovement.AccountsBsUser.accbsUser_country !==
                            "Venezuela" &&
                            selectedMovement.AccountsBsUser
                              .accbsUser_country !== "Estados Unidos" && (
                              <span>
                                (
                                {
                                  selectedMovement.AccountsBsUser
                                    .accbsUser_accountType
                                }
                                )
                              </span>
                            )}
                        </p>
                      )}
                      <p>
                        <strong>Monto a recibir:</strong>{" "}
                        {(parseFloat(selectedMovement.mov_amount) *
                            (exchangeRates.find(
                              (rate) =>
                                rate.country ===
                                  selectedMovement.AccountsBsUser?.accbsUser_country &&
                                rate.oldCurrency === selectedMovement.mov_currency
                            )?.value || 0)
                          ).toLocaleString("de-DE")}{" "}
                      </p>
                    </>
                  ) : (
                    // EFECTIVO
                    <>
                      <p>
                        <strong>Monto a recibir:</strong>{" "}
                        {selectedMovement?.mov_amount} USD
                      </p>
                      {selectedMovement?.mov_comment && (
                        <div className="user-comment-summary">
                          <hr />
                          <h4>Información suministrada por el usuario:</h4>
                          {selectedMovement.mov_comment
                            .split("\n")
                            .map((line, idx) => (
                              <p key={idx} style={{ margin: "0.2rem 0" }}>
                                {line}
                              </p>
                            ))}
                        </div>
                      )}
                    </>
                  )}
                </div>

                {/* Moneda y comprobante */}
                <div className="modal-actions" style={{ display: "flex", flexDirection: "column", alignItems: "stretch" }}>
                  <label>Moneda a enviar</label>
                  <select
                    value={payment}
                    onChange={(e) => setPayment(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "0.5rem",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      marginBottom: "1rem",
                      fontSize: "1rem",
                      background: "#f9f9f9",
                      outline: "none",
                      transition: "border 0.2s",
                    }}
                  >
                    <option value="">Selecciona una moneda...</option>
                    <option value="BS">Bolívares</option>
                    <option value="ARS">Pesos Argentinos</option>
                    <option value="COP">Pesos Colombianos</option>
                    <option value="CLP">Pesos Chilenos</option>
                    <option value="DOP">Pesos Dominicano</option>
                    <option value="PEN">Soles</option>
                    <option value="BRL">Reales Brasileños</option>
                    <option value="USD-EC">Dólar Ecuatoriano</option>
                    <option value="USD-PA">Dólar Panameño</option>
                    <option value="USD">Dólar Estadounidense</option>
                    <option value="EUR">Euro</option>
                  </select>

                  <label>Subir comprobante</label>
                  <input
                    type="file"
                    accept=".jpg,.JPG,.jpeg,.JPEG,.png,.PNG,image/jpeg,image/png"
                    onChange={(e) => {
                      setMovImg(e.target.files[0]);
                      setFileSelected(!!e.target.files[0]);
                    }}
                    style={{
                      width: "100%",
                      padding: "0.5rem",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      background: "#f9f9f9",
                      marginBottom: "1rem",
                      fontSize: "1rem",
                      outline: "none",
                      transition: "border 0.2s",
                    }}
                  />
                  {fileSelected && (
                    <p className="file-selected-message">
                      Archivo seleccionado: {movImg?.name}
                    </p>
                  )}
                </div>

                {/* Botones de aprobar / rechazar */}
                {!showRejectionReason ? (
                  <div className="modal-buttons">
                    <button
                      className="approve-btn"
                      onClick={handleApproveRemesa}
                      disabled={fileSelected === false || payment === ""}
                    >
                      Aprobar
                    </button>
                    <button
                      className="reject-btn"
                      onClick={() => setShowRejectionReason(true)}
                    >
                      Rechazar
                    </button>
                  </div>
                ) : (
                  <div className="rejection-reason open">
                    <label>Motivo del rechazo:</label>
                    <textarea
                      value={rejectionReason}
                      onChange={(e) => setRejectionReason(e.target.value)}
                    />
                    <div className="modal-buttons">
                      <button className="send-btn" onClick={handleRejectRemesa}>
                        Enviar
                      </button>
                      <button
                        className="btn-back"
                        onClick={() => setShowRejectionReason(false)}
                      >
                        Volver
                      </button>
                    </div>
                  </div>
                )}

                <div className="modal-actions">
                  <button
                    className="close-btn"
                    onClick={() => {
                      setIsModalOpen(false);
                      setIsProcessing(false);
                      setActionResult(null);
                      setShowRejectionReason(false);
                      setRejectionReason("");
                      setPayment("");
                      setFileSelected(false);
                      setMovImg(null);
                    }}
                  >
                    Cerrar
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      <NavBarAdm />
    </div>
  );
}

export { Dashboard };
